import { render } from "./TaskManageDialog.vue?vue&type=template&id=63dedf77&scoped=true"
import script from "./TaskManageDialog.vue?vue&type=script&lang=js"
export * from "./TaskManageDialog.vue?vue&type=script&lang=js"

import "./TaskManageDialog.vue?vue&type=style&index=0&id=63dedf77&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63dedf77"]])

export default __exports__